import * as React from 'react';
import { Link } from 'react-router-dom';
import { generatePath } from 'react-router';
import { MainType } from './Container';
import GrayArrow from 'Assets/Img/Icons/gray-arrow-icon.svg';
import { ROUTES } from 'shared/consts';
import AddCaseStatusForm from './components/addCaseStatusForm';

type P = {
  match: any;
  location: any;
  history: any;
};

class Main extends React.Component<MainType & P, any> {
  isEdit: boolean;
  constructor(props) {
    super(props);
    this.isEdit = this.isEditMode();
  }
  componentDidMount() {
    if (this.isEdit && this.props.location.state === undefined) {
      this.props.history.push(generatePath(ROUTES.CASE_DETAILS, { id: this.props.match.params.id }));
    }
  }
  handleSubmit = async (values) => {
    if (this.isEdit) {
      return this.props.actions.editCaseDescription(values, this.props.match.params.id);
    }
    await this.props.actions.addCaseDescription(values, this.props.match.params.id);
  };

  isEditMode = () => this.props.location.pathname.includes('edit');

  render() {
    const { params } = this.props.match;
    return (
      <div className="addCaseStatusDescription narrow-section">
        <div className="narrow-section__title">
          <Link to={generatePath(ROUTES.CASE_DETAILS, { id: params.id })}>
            <img src={GrayArrow} alt="" />
          </Link>
          <h2>{this.isEditMode ? 'Edytuj' : 'Dodaj'} wpis</h2>
        </div>
        <div className="add-customer__form-container">
          <AddCaseStatusForm onSubmit={this.handleSubmit} isEditMode={this.isEdit} initialValues={this.props.location.state ? this.props.location.state : undefined} />
        </div>
      </div>
    );
  }
}

export default Main;
